import { atom } from 'recoil'
import { AssignmentTypes } from 'services'

export const assignmentsList = atom<AssignmentTypes[]>({
  key: 'assignmentsList',
  default: []
})
